// extracted by mini-css-extract-plugin
module.exports = {"pro-avatar":"Rating_pro-avatar__9phC8"};